(function () {
  var backdrop = document.getElementById('vtoBackdrop');
  if (!backdrop) return;

  // Upload elements
  var closeBtn = document.getElementById('vtoClose');
  var fileInput = document.getElementById('vtoFile');
  var uploadArea = document.getElementById('vtoUploadArea');
  var editor = document.getElementById('vtoEditor');
  var preview = document.getElementById('vtoPreview');
  var photo = document.getElementById('vtoPhoto');
  var frame = document.getElementById('vtoFrame');
  var slider = document.getElementById('vtoSlider');
  var saveBtn = document.getElementById('vtoSave');
  var changeBtn = document.getElementById('vtoChange');

  // Camera elements
  var camVideo = document.getElementById('vtoCamVideo');
  var camCanvas = document.getElementById('vtoCamCanvas');
  var camStatus = document.getElementById('vtoCamStatus');
  var camActions = document.getElementById('vtoCamActions');
  var camCapture = document.getElementById('vtoCamCapture');
  var camCaptured = document.getElementById('vtoCamCaptured');
  var camCapturedImg = document.getElementById('vtoCamCapturedImg');
  var camSave = document.getElementById('vtoCamSave');
  var camRetake = document.getElementById('vtoCamRetake');
  var faceGuide = document.getElementById('vtoFaceGuide');
  var faceGuideText = document.getElementById('vtoFaceGuideText');
  var guideToggle = document.getElementById('vtoGuideToggle');

  // Tabs
  var tabs = backdrop.querySelectorAll('.vto-tab');
  var panels = backdrop.querySelectorAll('.vto-panel');

  var camStream = null, faceMesh = null, mpCamera = null, camRunning = false;
  var frameImg = new Image();
  frameImg.crossOrigin = 'anonymous';
  function vtoCurrentFrameSrc() {
    return (frame && frame.getAttribute('src')) || window.__vtoDefaultFrameSrc || window.__vtoFrameSrc || '';
  }
  frameImg.src = vtoCurrentFrameSrc();
  // Follow the selected variant — Alpine updates #vtoFrame's src when the color changes
  if (frame && window.MutationObserver) {
    new MutationObserver(function () {
      var s = vtoCurrentFrameSrc();
      if (s && s !== frameImg.getAttribute('src')) { frameImg.src = s; }
    }).observe(frame, { attributes: true, attributeFilter: ['src'] });
  }
  var capturedDataUrl = null;

  // ===== COLOR SWATCHES (per-variant frame swapping) =====
  var swatchBar = document.getElementById('vtoSwatchBar');
  var swatchRow = document.getElementById('vtoSwatches');
  var vNameEl = document.getElementById('vtoVariantName');
  var vPriceEl = document.getElementById('vtoVariantPrice');
  var vtoFrameCache = {};
  var prevFrameImg = null, swapT0 = 0;
  function vtoNow() { return window.performance ? performance.now() : Date.now(); }

  function vtoPreload(url) {
    if (!url) return null;
    if (vtoFrameCache[url]) return vtoFrameCache[url];
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.src = url;
    vtoFrameCache[url] = im;
    return im;
  }

  function vtoSetActive(id) {
    if (!swatchRow) return;
    swatchRow.querySelectorAll('.vto-swatch').forEach(function (s) {
      s.classList.toggle('is-active', String(s.dataset.variantId) === String(id));
    });
  }

  // silent = no crossfade (used for the initial/default paint)
  function vtoSelectVariant(v, silent) {
    if (!v || !v.url) return;
    vtoSetActive(v.id);
    if (vNameEl) vNameEl.textContent = v.color || v.title || '';
    if (vPriceEl) vPriceEl.textContent = v.price || '';
    var nu = vtoPreload(v.url);
    // Camera tab: crossfade the canvas-drawn frame
    var doCam = function () {
      prevFrameImg = (frameImg && frameImg.complete && frameImg.naturalWidth) ? frameImg : null;
      frameImg = nu;
      swapT0 = silent ? 0 : vtoNow();
    };
    if (nu.complete && nu.naturalWidth) doCam();
    else nu.addEventListener('load', doCam, { once: true });
    // Upload tab: fade the <img>
    if (frame) {
      if (silent) {
        frame.setAttribute('src', v.url);
      } else {
        frame.style.opacity = '0';
        var applyUp = function () { frame.setAttribute('src', v.url); frame.style.opacity = '1'; };
        if (nu.complete && nu.naturalWidth) setTimeout(applyUp, 150);
        else nu.addEventListener('load', function () { setTimeout(applyUp, 150); }, { once: true });
      }
    }
  }

  function vtoBuildSwatches() {
    var variants = window.__vtoVariants || [];
    if (!swatchRow || !swatchBar || !variants.length) return;
    swatchRow.innerHTML = '';
    variants.forEach(function (v) {
      vtoPreload(v.url); // preload every variant PNG up front → instant swaps
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vto-swatch';
      b.dataset.variantId = v.id;
      b.dataset.label = v.color || v.title || '';
      b.style.background = v.swatchColor || '#ccc';
      b.setAttribute('aria-label', v.color || v.title || 'Color');
      b.addEventListener('click', function () { vtoSelectVariant(v, false); });
      swatchRow.appendChild(b);
    });
    swatchBar.style.display = 'flex';
    // Default to the variant currently selected on the product page
    var cur = null, cid = window.__vtoCurrentVariantId;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(cid)) { cur = variants[i]; break; }
    }
    if (!cur) cur = variants[0];
    vtoSelectVariant(cur, true);
  }
  vtoBuildSwatches();

  // Guide toggle — controlled ONLY by button
  var guideVisible = true;

  // Native video dimensions (set after loadedmetadata)
  var nativeW = 0, nativeH = 0;

  // (lastLandmarks removed — capture now copies the live canvas directly)

  // ===== GUIDE TOGGLE =====
  guideToggle.addEventListener('click', function () {
    guideVisible = !guideVisible;
    guideToggle.textContent = guideVisible ? 'Guide: On' : 'Guide: Off';
    guideToggle.classList.toggle('off', !guideVisible);
    if (guideVisible) {
      faceGuide.style.opacity = '0.8';
      faceGuideText.style.opacity = '0.8';
    } else {
      faceGuide.style.opacity = '0';
      faceGuideText.style.opacity = '0';
    }
  });

  // ===== TABS =====
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('active'); });
      panels.forEach(function (p) { p.classList.remove('active'); });
      tab.classList.add('active');
      var target = tab.dataset.tab === 'camera' ? 'vtoPanelCamera' : 'vtoPanelUpload';
      document.getElementById(target).classList.add('active');
      if (tab.dataset.tab === 'camera') startCamera();
      else stopCamera();
    });
  });

  // ===== UPLOAD =====
  function resetUpload() {
    uploadArea.style.display = '';
    editor.style.display = 'none';
    photo.src = '';
    fileInput.value = '';
    frame.style.width = '35%';
    frame.style.top = '50%';
    frame.style.left = '50%';
    frame.style.transform = 'translate(-50%,-50%)';
    slider.value = 35;
  }

  function closeModal() {
    backdrop.classList.remove('open');
    resetUpload();
    stopCamera();
    tabs.forEach(function (t) { t.classList.remove('active'); });
    panels.forEach(function (p) { p.classList.remove('active'); });
    tabs[0].classList.add('active');
    panels[0].classList.add('active');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-vto-open')) {
      backdrop.classList.add('open');
      if (window.innerWidth < 768 && navigator.mediaDevices) tabs[1].click();
    }
  });
  closeBtn.addEventListener('click', closeModal);
  backdrop.addEventListener('click', function (e) { if (e.target === backdrop) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && backdrop.classList.contains('open')) closeModal(); });

  fileInput.addEventListener('change', function () {
    var file = fileInput.files[0];
    if (!file) return;
    var reader = new FileReader();
    reader.onload = function (e) {
      photo.src = e.target.result;
      uploadArea.style.display = 'none';
      editor.style.display = 'block';
    };
    reader.readAsDataURL(file);
  });
  changeBtn.addEventListener('click', resetUpload);

  slider.addEventListener('input', function () { frame.style.width = slider.value + '%'; });

  // Drag
  var dragging = false, ox = 0, oy = 0;
  function pos(e) { var t = e.touches ? e.touches[0] : e; return { x: t.clientX, y: t.clientY }; }
  frame.addEventListener('mousedown', startDrag);
  frame.addEventListener('touchstart', startDrag, { passive: false });
  document.addEventListener('mousemove', onDrag);
  document.addEventListener('touchmove', onDrag, { passive: false });
  document.addEventListener('mouseup', endDrag);
  document.addEventListener('touchend', endDrag);
  function startDrag(e) {
    e.preventDefault(); dragging = true; frame.classList.add('dragging');
    var p = pos(e), r = frame.getBoundingClientRect();
    ox = p.x - r.left - r.width / 2; oy = p.y - r.top - r.height / 2;
  }
  function onDrag(e) {
    if (!dragging) return; e.preventDefault();
    var p = pos(e), cr = preview.getBoundingClientRect();
    frame.style.left = Math.max(0, Math.min(100, ((p.x - ox - cr.left) / cr.width) * 100)) + '%';
    frame.style.top = Math.max(0, Math.min(100, ((p.y - oy - cr.top) / cr.height) * 100)) + '%';
    frame.style.transform = 'translate(-50%,-50%)';
  }
  function endDrag() { dragging = false; frame.classList.remove('dragging'); }

  // Upload Save
  saveBtn.addEventListener('click', function () {
    var c = document.createElement('canvas'), ctx = c.getContext('2d'), img = new Image();
    img.onload = function () {
      c.width = img.naturalWidth; c.height = img.naturalHeight; ctx.drawImage(img, 0, 0);
      var cr = preview.getBoundingClientRect(), fr = frame.getBoundingClientRect();
      var sx = c.width / cr.width, sy = c.height / cr.height;
      var fi = new Image(); fi.crossOrigin = 'anonymous';
      fi.onload = function () { ctx.drawImage(fi, (fr.left - cr.left) * sx, (fr.top - cr.top) * sy, fr.width * sx, fr.height * sy); dlCanvas(c); };
      fi.onerror = function () { dlCanvas(c); }; fi.src = frame.src;
    };
    img.src = photo.src;
  });
  function dlCanvas(c) { var a = document.createElement('a'); a.download = 'eyebuddy-tryon.png'; a.href = c.toDataURL('image/png'); a.click(); }

  // ===== CAMERA + MEDIAPIPE =====

  function loadScript(url) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script'); s.src = url; s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  var mpLoaded = false;
  function loadMediaPipe() {
    if (mpLoaded) return Promise.resolve();
    return loadScript('https://cdn.jsdelivr.net/npm/@mediapipe/camera_utils/camera_utils.js')
      .then(function () { return loadScript('https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/face_mesh.js'); })
      .then(function () { mpLoaded = true; });
  }

  function updateGuideOpacity(faceDetected) {
    if (!guideVisible) return;
    if (faceDetected) {
      faceGuide.style.opacity = '0.4';
      faceGuideText.style.opacity = '0.4';
    } else {
      faceGuide.style.opacity = '0.8';
      faceGuideText.style.opacity = '0.8';
    }
  }

  // Draw frame overlay given a canvas context, dimensions, and landmarks.
  // Landmarks are MediaPipe normalized coords (0-1).
  // This function does NOT mirror — caller must handle mirroring if needed.
  function drawFrameAtLandmarks(ctx, w, h, landmarks) {
    if (!frameImg.complete || frameImg.naturalWidth === 0) return;
    if (!landmarks || landmarks.length === 0) return;
    // Shared sizing math lives in tryon-face-fit.js so the standalone
    // /pages/try-on page renders frames identically. Do not duplicate it here.
    var t = swapT0 ? Math.min((vtoNow() - swapT0) / 150, 1) : 1;
    window.TryOnFaceFit.drawFrameAtLandmarks(ctx, w, h, landmarks, frameImg, {
      prevFrameImg: prevFrameImg,
      alpha: t
    });
    if (t >= 1) { prevFrameImg = null; swapT0 = 0; }
  }

  function startCamera() {
    if (camRunning) return;
    camStatus.textContent = 'Loading camera...';
    camStatus.classList.remove('hidden');
    camActions.style.display = 'none';
    camCaptured.style.display = 'none';
    capturedDataUrl = null;

    // Reset guide
    guideVisible = true;
    guideToggle.textContent = 'Guide: On';
    guideToggle.classList.remove('off');
    faceGuide.style.opacity = '0.8';
    faceGuideText.style.opacity = '0.8';

    var timeout = setTimeout(function () {
      if (!camRunning) camStatus.textContent = 'Camera timed out. Try uploading a photo instead.';
    }, 15000);

    loadMediaPipe().then(function () {
      if (!navigator.mediaDevices) throw new Error('No camera');
      return navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'user', width: { ideal: 640 }, height: { ideal: 480 } }, audio: false
      });
    }).then(function (stream) {
      clearTimeout(timeout);
      camStream = stream;
      camVideo.srcObject = stream;
      camVideo.onloadedmetadata = function () {
        nativeW = camVideo.videoWidth;
        nativeH = camVideo.videoHeight;

        // Set canvas pixel dimensions to match video native res exactly
        camCanvas.width = nativeW;
        camCanvas.height = nativeH;

        initFaceMesh();
        camStatus.classList.add('hidden');
        camActions.style.display = '';
        camRunning = true;
      };
    }).catch(function () {
      clearTimeout(timeout);
      camStatus.textContent = 'Could not access camera. Try uploading a photo instead.';
    });
  }

  function initFaceMesh() {
    if (!window.FaceMesh) return;
    faceMesh = new FaceMesh({
      locateFile: function (file) {
        return 'https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/' + file;
      }
    });
    faceMesh.setOptions({
      maxNumFaces: 1, refineLandmarks: false,
      minDetectionConfidence: 0.5, minTrackingConfidence: 0.5
    });
    faceMesh.onResults(onFaceResults);

    if (window.Camera) {
      mpCamera = new Camera(camVideo, {
        onFrame: function () {
          if (!camRunning || !faceMesh) return Promise.resolve();
          return faceMesh.send({ image: camVideo });
        },
        width: nativeW || 640, height: nativeH || 480
      });
      mpCamera.start();
    }
  }

  function onFaceResults(results) {
    if (!camRunning) return;

    // Keep canvas pixel dimensions in sync with video (MediaPipe Camera may resize)
    var curW = camVideo.videoWidth || nativeW;
    var curH = camVideo.videoHeight || nativeH;
    if (curW && curH && (camCanvas.width !== curW || camCanvas.height !== curH)) {
      camCanvas.width = curW;
      camCanvas.height = curH;
      nativeW = curW;
      nativeH = curH;
    }

    var ctx = camCanvas.getContext('2d');
    var w = camCanvas.width;
    var h = camCanvas.height;

    ctx.clearRect(0, 0, w, h);

    var hasFace = results && results.multiFaceLandmarks && results.multiFaceLandmarks.length > 0;
    updateGuideOpacity(hasFace);

    if (hasFace) {
      // Draw frame overlay using raw landmark coords.
      // The canvas has CSS transform:scaleX(-1) matching the video's CSS mirror,
      // so we draw in non-mirrored coord space and CSS flips both video+canvas together.
      drawFrameAtLandmarks(ctx, w, h, results.multiFaceLandmarks[0]);
    }
  }

  function stopCamera() {
    camRunning = false;
    if (mpCamera) { try { mpCamera.stop(); } catch (e) {} mpCamera = null; }
    if (faceMesh) { try { faceMesh.close(); } catch (e) {} faceMesh = null; }
    if (camStream) { camStream.getTracks().forEach(function (t) { t.stop(); }); camStream = null; }
    camVideo.srcObject = null;
    nativeW = 0;
    nativeH = 0;
    var ctx = camCanvas.getContext('2d');
    ctx.clearRect(0, 0, camCanvas.width, camCanvas.height);
    camStatus.classList.remove('hidden');
    camStatus.textContent = 'Loading camera...';
    camActions.style.display = 'none';
    camCaptured.style.display = 'none';
  }

  // Capture — composite mirrored video + live overlay canvas
  camCapture.addEventListener('click', function () {
    // Use the actual current video dimensions (most reliable source of truth)
    var vw = camVideo.videoWidth || nativeW;
    var vh = camVideo.videoHeight || nativeH;
    if (!vw || !vh) return;

    var c = document.createElement('canvas');
    c.width = vw;
    c.height = vh;
    var ctx = c.getContext('2d');

    // Step 1: Draw mirrored video at its native resolution
    ctx.save();
    ctx.translate(vw, 0);
    ctx.scale(-1, 1);
    ctx.drawImage(camVideo, 0, 0, vw, vh);

    // Step 2: Draw the overlay canvas with the same mirror transform.
    // camCanvas pixel dimensions match the video native res (set on loadedmetadata),
    // so draw it at vw x vh to align perfectly with the video frame.
    // Use camCanvas.width/height as source to avoid any mismatch.
    ctx.drawImage(camCanvas, 0, 0, camCanvas.width, camCanvas.height, 0, 0, vw, vh);
    ctx.restore();

    capturedDataUrl = c.toDataURL('image/png');

    // Stop camera
    camRunning = false;
    if (mpCamera) { try { mpCamera.stop(); } catch (e) {} mpCamera = null; }
    if (faceMesh) { try { faceMesh.close(); } catch (e) {} faceMesh = null; }
    if (camStream) { camStream.getTracks().forEach(function (t) { t.stop(); }); camStream = null; }
    camVideo.srcObject = null;

    // Hide live view, show captured image
    camVideo.style.display = 'none';
    camCanvas.style.display = 'none';
    camCapturedImg.src = capturedDataUrl;
    camStatus.classList.add('hidden');
    faceGuide.style.opacity = '0';
    faceGuideText.style.opacity = '0';
    guideToggle.style.display = 'none';
    camActions.style.display = 'none';
    camCaptured.style.display = '';
  });

  // Retake — fully restart camera from scratch
  camRetake.addEventListener('click', function () {
    capturedDataUrl = null;
    camCaptured.style.display = 'none';
    camCapturedImg.src = '';
    camVideo.style.display = '';
    camCanvas.style.display = '';
    guideToggle.style.display = '';
    camStream = null;
    faceMesh = null;
    mpCamera = null;
    camRunning = false;
    nativeW = 0;
    nativeH = 0;
    var ctx = camCanvas.getContext('2d');
    ctx.clearRect(0, 0, camCanvas.width, camCanvas.height);
    startCamera();
  });

  // Camera Save
  camSave.addEventListener('click', function () {
    if (!capturedDataUrl) return;
    var a = document.createElement('a');
    a.download = 'eyebuddy-tryon.png';
    a.href = capturedDataUrl;
    a.click();
  });
})();
